import { M8PaymentTransactionDTO } from 'services/production/types';
import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  id: number;
};

export const getPaymentTransactionsById = async (
  params: Params
): Promise<M8PaymentTransactionDTO> => {
  const response = await customFetch(
    getM8AdminURL(`getPaymentTransactionsById?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  return response.json();
};
